import { h } from 'preact'
import { RouteParam, getString, getValgtype } from '../../../lib/simple-routing/params'
import { AppRoute } from '../route'
import { AppStore } from '../../store'
import { fetchGrunndata } from '../../store/actions/grunndata'
import { fetchDataForWidget } from '../../store/actions'
import { WidgetFrame } from '../../components/frames/WidgetFrame/WidgetFrame'
import { selectGeografi } from '../../store/selectors/grunndata'
import { toOppslutningTableItem } from '../../components/moduler/Oppslutning/mapping'
import { ResultatContainer } from '../../components/resultater/Resultat/Resultat'
import { Tendens } from '../../components/moduler/Tendens/Tendens'
import { HasOppslutning } from '../../components/shared/HasOppslutning/HasOppslutning'
import { WidgetFooter } from '../../components/shared/WidgetFooter/WidgetFooter'

export const tendensRoute: AppRoute = {
  path: `/valg/2019/resultat/widget/:locale/tendens/:valgtype(kommune|fylke)/`,
  widget: true,
  widgetTitle: (params: RouteParam[]) => {
    const valgtype = getValgtype(params)
    const valgdesc = valgtype === 'kommune' ? 'KO' : 'FY'
    return `Tendens – ${valgdesc}`
  },
  onLoad: async (store: AppStore) => {
    return store.dispatch(fetchGrunndata())
  },
  onRouteChanged: async (store: AppStore, params: RouteParam[]) => {
    const paramId = getString(params, 'id') || ''
    const valgtype = getValgtype(params)
    const geo = selectGeografi(store.getState(), paramId)
    return store.dispatch(fetchDataForWidget(geo, valgtype))
  },
  render: params => {
    const valgtype = getValgtype(params)

    return (
      <WidgetFrame>
        <ResultatContainer type="auto">
          {(resultat, geografi, locale) => {
            const { partier } = resultat

            return (
              <HasOppslutning partier={partier}>
                <Tendens
                  grunndata={geografi}
                  items={toOppslutningTableItem(partier, locale, false)}
                  valgtype={valgtype}
                  widgetFooter={<WidgetFooter resultat={resultat} valgtype={valgtype} />}
                />
              </HasOppslutning>
            )
          }}
        </ResultatContainer>
      </WidgetFrame>
    )
  }
}
